// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"c0adc26a","305":"704facc0","424":"06da64f5","668":"9278e1ca","856":"9278e1ca","885":"6ac39b74","917":"9341ec2f"}[chunkId] + ".chunk.css";
};